import {queryOptions} from '@tanstack/react-query';
import {create, windowedFiniteBatchScheduler} from '@yornaath/batshit';

import {getHotelImages, type Image} from '@/api/bffSupport';

const hotelImagesBatcher = create({
  fetcher: async (hotelIds: Array<string>) => {
    const response = await getHotelImages({hotels: hotelIds});
    return 'hotels' in response.data && Array.isArray(response.data.hotels)
      ? response.data.hotels
      : [];
  },
  resolver: (items, query) => {
    return items.find((item) => item.hotelId == query)?.images ?? [];
  },
  scheduler: windowedFiniteBatchScheduler({
    maxBatchSize: 25,
    windowMs: 10,
  }),
});

export const hotelImages = (hotelId: string) => {
  return queryOptions({
    queryKey: ['bff-support', 'hotel-images', hotelId],
    queryFn: (): Promise<Array<Image>> => {
      return hotelImagesBatcher.fetch(hotelId);
    },
    retry: false,
  });
};
